export default {
  PARTNERSHIP: 'N',
  CORPORATION: 'C',
  LLC: 'L',
  PROPRIETORSHIP: 'S',
};
